import { buildGuideSketches, buildVisualGuides } from "@plaatplan/i18n";
import { useMemo } from "react";
import { useLocale } from "./useLocale.js";

export function useVisualGuides() {
  const { preferences } = useLocale();
  return useMemo(
    () => buildVisualGuides(preferences.locale),
    [preferences.locale],
  );
}

export function useGuideSketches() {
  const { preferences } = useLocale();
  return useMemo(
    () => buildGuideSketches(preferences.locale),
    [preferences.locale],
  );
}
